import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  ModalHeader,
  ModalBody,
  Row,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { getFormattedDateTime } from '../../helpers/DateTime';
import {
  getCollectionsList,
  getTermsList,
} from '../../helpers/FileHistory';

const FileDiffModal = ({
  log,
  handleClose,
}) => {
  const intl = useIntl();

  const { diff } = log;
  const mode = log.action === 'file_updated' ? 'edit' : 'new';

  return (
    <>
      <ModalHeader toggle={handleClose} className="modal-header-center">
        { mode === 'edit' ? intl.formatMessage({ defaultMessage: 'File edit details' }) :
          intl.formatMessage({ defaultMessage: 'File details' }) }
      </ModalHeader>
      <ModalBody>
        {mode === 'edit' ? (
          <>
            {diff.name && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Name' })}</Col>
                </Row>
                <Row className="diff">
                  <Col className="diff-old">
                    {diff.name.old ? diff.name.old : ''}
                  </Col>
                  <Col className="diff-new">
                    {diff.name.new ? diff.name.new : ''}
                  </Col>
                </Row>
              </>
            )}
            {diff.description && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Description' })}</Col>
                </Row>
                <Row className="diff">
                  <Col className="diff-old">
                    {diff.description.old ? diff.description.old : ''}
                  </Col>
                  <Col className="diff-new">
                    {diff.description.new ? diff.description.new : ''}
                  </Col>
                </Row>
              </>
            )}
            {diff.custom_fields && diff.custom_fields.map(cf => (
              <>
                <Row className="diff-title">
                  <Col>{cf.name}</Col>
                </Row>
                <Row className="diff">
                  <Col className="diff-old">
                    {cf.old ? cf.old : ''}
                  </Col>
                  <Col className="diff-new">
                    {cf.new ? cf.new : ''}
                  </Col>
                </Row>
              </>
            ))}
            {(diff.public === true || diff.public === false) && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Visibility' })}</Col>
                </Row>
                <Row className="diff">
                  <Col className="diff-old">
                    {diff.public.old ? (
                      <span className="file-history-access"><i className="fas fa-eye" />{' '}
                        {intl.formatMessage({ defaultMessage: 'Open' })}
                      </span>
                    ) : (
                      <span className="file-history-access"><i className="fas fa-lock" />{' '}
                        {intl.formatMessage({ defaultMessage: 'Restricted' })}
                      </span>
                    )}
                  </Col>
                  <Col className="diff-new">
                    {diff.public.new ? (
                      <span className="file-history-access"><i className="fas fa-eye" />{' '}
                        {intl.formatMessage({ defaultMessage: 'Open' })}
                      </span>
                    ) : (
                      <span className="file-history-access"><i className="fas fa-lock" />{' '}
                        {intl.formatMessage({ defaultMessage: 'Restricted' })}
                      </span>
                    )}
                  </Col>
                </Row>
              </>
            )}
            {diff.status && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Status' })}</Col>
                </Row>
                <Row className="diff">
                  <Col className="diff-old">
                    <span className="file-history-status">
                      {diff.status.old && (
                        <>
                          <i className="file-status" style={{ backgroundColor: diff.status.old.color }} />
                          {' '}{diff.status.old.name}
                        </>
                      )}
                    </span>
                  </Col>
                  <Col className="diff-new">
                    <span className="file-history-status">
                      {diff.status.new ? (
                        <>
                          <i className="file-status" style={{ backgroundColor: diff.status.new.color }} />
                          {' '}{diff.status.new.name}
                        </>
                      ) : (
                        <span>{intl.formatMessage({ defaultMessage: '-- not set --' })}</span>
                      )}
                    </span>
                  </Col>
                </Row>
              </>
            )}
            {diff.expires_at && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Expires on' })}</Col>
                </Row>
                <Row className="diff">
                  <Col className="diff-old">
                    {diff.expires_at.old ? getFormattedDateTime(diff.expires_at.old) : ''}
                  </Col>
                  <Col className="diff-new">
                    {diff.expires_at.new ? getFormattedDateTime(diff.expires_at.new) : ''}
                  </Col>
                </Row>
              </>
            )}
          </>
        ) : (
          <>
            {(diff.name && diff.name.new) && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Name' })}</Col>
                </Row>
                <Row className="diff">
                  <Col>
                    {diff.name.new ? diff.name.new : ''}
                  </Col>
                </Row>
              </>
            )}
            {(diff.description && diff.description.new) && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Description' })}</Col>
                </Row>
                <Row className="diff">
                  <Col>
                    {diff.description.new ? diff.description.new : ''}
                  </Col>
                </Row>
              </>
            )}
            {diff.custom_fields && diff.custom_fields.map(cf => (
              <Fragment key={cf.id}>
                <Row className="diff-title">
                  <Col>{cf.name}</Col>
                </Row>
                <Row className="diff">
                  <Col>
                    {cf.new ? cf.new : ''}
                  </Col>
                </Row>
              </Fragment>
            ))}
            {(diff.public === true || diff.public === false) && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Visibility' })}</Col>
                </Row>
                <Row className="diff">
                  <Col>
                    {(diff.public.new || diff.public) ? (
                      <span className="file-history-access"><i className="fas fa-eye" />{' '}
                        {intl.formatMessage({ defaultMessage: 'Open' })}
                      </span>
                    ) : (
                      <span className="file-history-access"><i className="fas fa-lock" />{' '}
                        {intl.formatMessage({ defaultMessage: 'Restricted' })}
                      </span>
                    )}
                  </Col>
                </Row>
              </>
            )}
            {(diff.status && diff.status.new) && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Status' })}</Col>
                </Row>
                <Row className="diff">
                  <Col>
                    <span className="file-history-status">
                      {diff.status.new ? (
                        <>
                          <i className="file-status" style={{ backgroundColor: diff.status.new.color }} />
                          {' '}{diff.status.new.name}
                        </>
                      ) : (
                        <span>{intl.formatMessage({ defaultMessage: '-- not set --' })}</span>
                      )}
                    </span>
                  </Col>
                </Row>
              </>
            )}
            {(diff.expires_at && diff.expires_at.new) && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Expires on' })}</Col>
                </Row>
                <Row className="diff">
                  <Col>
                    {diff.expires_at.new ? getFormattedDateTime(diff.expires_at.new) : ''}
                  </Col>
                </Row>
              </>
            )}
            {diff.terms && (
              diff.terms.map(t => (
                <Fragment key={t.object.id}>
                  <Row className="diff-title">
                    <Col>{t.object ? t.object.plural : ''}</Col>
                  </Row>
                  <Row className="diff">
                    <Col>
                      {getTermsList(t)}
                    </Col>
                  </Row>
                </Fragment>
              ))
            )}
            {diff.collections && (
              <>
                <Row className="diff-title">
                  <Col>{intl.formatMessage({ defaultMessage: 'Collections' })}</Col>
                </Row>
                <Row className="diff">
                  <Col>
                    {getCollectionsList({ diff: diff.collections })}
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      </ModalBody>
    </>
  );
};

FileDiffModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  log: PropTypes.object.isRequired,
};

export default FileDiffModal;
